<span
  class="cads-badge-bit"
  [class.cads-badge-bit--xs]="isXs()"
  [ngStyle]="cssVars()"
>
  @if (icon(); as iconName) {
    <span class="cads-badge-bit__icon material-symbols-outlined" aria-hidden="true">{{ iconName }}</span>
  } @else {
    <span class="cads-badge-bit__dot" aria-hidden="true"></span>
  }
  <span class="cads-badge-bit__label">{{ effectiveConfig().label }}</span>
</span>
